module.exports = __webpack_public_path__ + "img/hyundai_santafe.f8dda847.png";